<template>
  <div style="height: 100vh;background-color: #ffffff;">
    <vue-element-loading
      is-full-screen
      :active="loading && !regised"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <div class="navbar nav-main w-100" style="background-color:#23409A;color:white">
      <h3 class="w-100 text-center my-3">ยืนยันตัวตน</h3>
    </div>
    <div class="w-100 session-with-nav " style="height: calc(100vh - 67px);overflow: auto;">
      <div style="text-align: right;" class="mr-2 mt-2">
        <v-btn color="#23409a" outlined icon @click="pop = true">
          <span class="fs-20 text-blue">?</span>
        </v-btn>
      </div>
      <div class="mb-3 flex-all-center">
        <div>
          <v-img
            class="my-5 radius-circle"
            style="width:70vw;height:auto"
            src="@/assets/rafiki.png"
          ></v-img>
        </div>
      </div>
      <div class="w-100 px-8">
        <div class="text-center">
          ระบบได้ทำการส่งรหัส OTP ไปยังเบอร์โทรศัพท์ของท่าน {{ showPhoneno }}
        </div>
        <div class="fs-14 text-gray text-center mt-2">
          <span>Ref :</span>
          <span class="mx-1" v-if="ref">{{ ref.refCode }}</span>
          <CountDownTimer
            class="mx-1"
            style="font-size: 14px"
            v-if="showCountdowntimer"
            :startmin="timeleft"
            @ontimeout="showCountdowntimer = false"
          ></CountDownTimer>
          <div class="mt-5">
            <custom-input
              :maxlength="6"
              v-model="otp"
              :center="true"
              placeholder="OTP"
              numberOnly
              outlined
            ></custom-input>
          </div>
          <div style="color:black">
            <div>
              ไม่ได้รับรหัส OTP
              <span @click="sentOtp" class="text-blue" style="text-decoration: underline;"
                >ส่งใหม่อีกครั้ง</span
              >
            </div>
          </div>
        </div>
        <div class="flex-all-center mt-8 mb-5">
          <v-btn
            :loading="loading"
            @click="submitOtp"
            class="col-8 main-btn"
            style="color:white;"
            color="#23409a"
            >ถัดไป</v-btn
          >
        </div>
      </div>

      <v-dialog v-model="pop" :overlay="false" max-width="500px" transition="dialog-transition">
        <v-card class="py-2 px-5">
          <div class="text-center">
            OTP คือ รหัสที่ส่งผ่านระบบ SMS (ข้อความ) ตามเบอร์โทรศัพท์ที่แจ้งไว้
          </div>
          <div style="text-align: center;" class="mt-2">
            <v-btn color="#23409a" @click="askmore">
              <span class="text-white">สอบถามเพิ่มเติม</span>
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import VueElementLoading from 'vue-element-loading'
import CountDownTimer from '@/components/CountDownTimer.vue'
export default {
  components: { VueElementLoading, CountDownTimer },
  data() {
    return {
      pop: false,
      userData: null,
      loading: true,
      loadingMain: true,
      showCountdowntimer: true,
      timeleft: 5,
      otp: ''
    }
  },
  computed: {
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    profile() {
      return this.$store.state.profile
    },
    userId() {
      return this.$store.state.profile.userId
    },
    regised() {
      if (
        this.userId &&
        this.userData &&
        this.userData.cardnumber &&
        this.userData.status == 'ผูกบัญชีแล้ว'
      ) {
        return true
      } else {
        return false
      }
    },
    showPhoneno() {
      if (
        this.$store.state &&
        this.$store.state.ref &&
        this.userData &&
        this.userData.phoneno.length === 10
      ) {
        let phone = this.userData.phoneno
        let data = [phone[0], phone[1], phone[2], '-xxx-', phone[6], phone[7], phone[8], phone[9]]
        return data.join('')
      } else {
        return this.userData && this.userData.phoneno ? this.userData.phoneno : ''
      }
    },
    ref() {
      return this.$store.state.ref
    },
    userDataCom() {
      return this.$store.state.userData
    }
  },
  watch: {
    userId: {
      immediate: true,
      handler(userId) {
        if (userId) {
          this.setup()
        }
      }
    }
  },
  mounted() {
    //   this.setup()
  },
  methods: {
    async askmore() {
      await this.$store.dispatch('sendMessage', 'สอบถามเพิ่มเติมเรื่อง OTP')
      this.$liff.closeWindow()
    },
    async setup() {
      if (this.userDataCom) {
        this.userData = this.userDataCom
      } else {
        await this.fetchUserData(this.userId)
      }
      await this.sentOtp()
      this.loading = false
      this.loadingMain = false
    },
    async sentOtp() {
      let body = {
        LineUserId: this.userId,
        PhoneNumber: this.userData.phoneno,
        pageid: config.pageid
      }
      this.loading = true
      this.showCountdowntimer = false
      let res = await api.regisedSendOtp(body)
      this.showCountdowntimer = true

      this.loading = false
      if (res.responsecode == 200) {
        this.$store.state.ref = res.data
      } else if (res.responsecode == 300) {
        this.$swal.fire({
          type: 'error',
          text: 'ไม่มีข้อมูลในระบบ'
        })
        this.count++
        this.$store.dispatch('conutRegis', this.count)
      }
    },
    async submitOtp() {
      let body = {
        userId: this.$store.state.profile.userId,
        refOTP: this.otp,
        phoneNumber: this.userData.phoneno,
        pageid: config.pageid
      }
      this.loading = true
      let res = await api.checkOtp(body)
      this.loading = false
      if (res.responsecode == 200) {
        if (res.data.message == 'match') {
          // go on
          this.$store.state.checkOtp = true
          this.$router.push('/selectAddress')
        } else {
          this.$swal.fire({
            type: 'error',
            text: 'OTP หมดอายุ กรุณากด ส่งรหัสใหม่ อีกครั้ง'
          })
        }
        // this.$emit("next");
      } else if (res.responsecode == 300) {
        this.$swal.fire({
          type: 'error',
          text: 'OTP หมดอายุ กรุณากด ส่งรหัสใหม่ อีกครั้ง'
        })
      }
    },
    async fetchUserData(userId) {
      if (userId) {
        let res = await api.getUser(userId)
        if (res.responsecode == 200 && res.data.id) {
          this.userData = res.data
          this.$store.dispatch('setUserData', this.userData)
        } else {
          console.log('error fetch user data')
        }
      }
    }
  }
}
</script>

<style></style>
